import { enableProdMode, importProvidersFrom } from '@angular/core';


import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PanelModule } from 'primeng/panel';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { CommonBindingDataService } from './app/modules/shared/services/common-binding-data.service';
import { HttpErrorHandler } from './app/modules/shared/services/http-error-handler.service';
import { MiMissingTranslationHandlerService } from './app/modules/shared/services/mi-missing-translation-handler.service';
import { MiTranslateLoaderService } from './app/modules/shared/services/mi-translate-loader.service';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}




bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule, FormsModule, ReactiveFormsModule, PanelModule, EditorModule, DialogModule, MultiSelectModule, AppRoutingModule, FieldsetModule, OverlayPanelModule, CalendarModule, FileUploadModule, ConfirmDialogModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: MiTranslateLoaderService
        },
        missingTranslationHandler: {
          provide: MissingTranslationHandler,
          useClass: MiMissingTranslationHandlerService
        }
      })
    ),
    HttpErrorHandler, MessageService, CommonBindingDataService, ConfirmationService,
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi())
  ]
})
  .catch(err => console.log(err));
